import useHelpers from "../../../helpers";
import useStrings from "../../../strings";
import useInitialStates from "../../initialStates";

const useAuthReducers = () => {
  // Helpers
  const { useCreateReducer } = useHelpers();
  const { createReducer } = useCreateReducer();

  //strings
  const { useTypes } = useStrings();
  const { useAuthTypes } = useTypes();
  const { LOGIN, LOGOUT, LOADER_OFF, LOADER_ON, SET_AUTH_TOKEN, SET_MFA_PENDING, CLEAR_MFA_PENDING, UPDATE_PERMISSIONS, UPDATE_SESSION } = useAuthTypes();

  // State
  const { useAuthInitialStates } = useInitialStates();
  const { sessionInitialState, mfaPendingInitialState } = useAuthInitialStates();

  const sessionHandler = {
    [LOGIN](state, action) {
      const { payload } = action;
      const { auth_token, user, isKeycloakAuth } = payload;

      // Extract permissions from first role (using first role only as per requirements)
      // Filter to only include ALLOW type permissions, exclude DENY
      // Note: null type is treated as ALLOW (inherited from role)
      const allPermissions = user.rol?.[0]?.permissions || [];
      const permissions = allPermissions.filter(p => p.type === 'ALLOW' || p.type === null);

      return {
        ...state,
        authToken: auth_token,
        name: user.name,
        lastname: user.last_name,
        email: user.email,
        rol: user?.rol[0]?.name,
        country_id: user.country_id || [],
        isKeycloakAuth: isKeycloakAuth || false,
        permissions: permissions,
        permissionsLoaded: true, // Mark permissions as loaded
      };
    },
    [SET_AUTH_TOKEN](state, action) {
      const { payload } = action;
      const { authToken, isKeycloakAuth } = payload;

      return {
        ...state,
        authToken: authToken,
        isKeycloakAuth: isKeycloakAuth || false,
      };
    },
    [UPDATE_PERMISSIONS](state, action) {
      const { payload } = action;

      return {
        ...state,
        permissions: payload,
        permissionsLoaded: true,
      };
    },
    [UPDATE_SESSION](state, action) {
      const { payload } = action;

      return {
        ...state,
        ...payload,
      };
    },
    [LOGOUT]() {
      return sessionInitialState;
    },
    [LOADER_ON](state) {
      return {...state, loader: true};
    },
    [LOADER_OFF](state) {
      return {...state, loader: false}
    }
  };

  const session = createReducer(sessionInitialState, sessionHandler);

  const mfaPendingHandler = {
    [SET_MFA_PENDING](state, action) {
      const { payload } = action;
      return {
        ...state,
        email: payload.email,
        password: payload.password,
        timestamp: payload.timestamp,
      };
    },
    [CLEAR_MFA_PENDING]() {
      return mfaPendingInitialState;
    },
  };

  const mfaPending = createReducer(mfaPendingInitialState, mfaPendingHandler);

  return {
    session,
    mfaPending,
  };
};

export default useAuthReducers;
